export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

// NEW: password change history
export const GET_PASSWORD_HISTORY = "GET_PASSWORD_HISTORY";
export const GET_PASSWORD_HISTORY_SUCCESS = "GET_PASSWORD_HISTORY_SUCCESS";
export const GET_PASSWORD_HISTORY_ERROR = "GET_PASSWORD_HISTORY_ERROR";